export default __webpack_public_path__ + "static/media/tiersRate.136bed92.svg";